module.exports = __webpack_public_path__ + "img/notes.42fb3463.png";